import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-session-timeout-modal",
  templateUrl: "./session-timeout-modal.component.html",
  styleUrls: ["./session-timeout-modal.component.scss"]
})
export class SessionTimeoutModalComponent implements OnInit {
  public redirectLink: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.redirectLink = this.route.snapshot.data.redirectLink;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/session-timeout-modal/session-timeout-modal.component.ts